import { MediaChannel } from "../../Business/dto/Brief";
import { ExternalDataPicker } from "./ExternalDataPicker";
import { DataKey } from "../../Business/dto/ExternalSystemElement";
import { faNewspaper } from "@fortawesome/free-regular-svg-icons";
import { useTranslation } from "react-i18next";

export interface MediaChannelPickerProps {
    setSelectedMediaChannels: (mediaChannels: MediaChannel[]) => void;
    filterData?: any;
    disabled?: boolean;
    required?: boolean;
    value: MediaChannel[] | undefined;
}

export const MediaChannelPicker = (props: MediaChannelPickerProps) => {
    const { t } = useTranslation();

    return (
        <>
                <ExternalDataPicker
                    disabled={props.disabled}
                    setSelectedData={props.setSelectedMediaChannels}
                    placeholder={t("supports")}
                    multiple
                    dataKey={DataKey.MediaChannel}
                    icon={faNewspaper}
                    controlId="mediaChannelPicker"
                    required={props.required}
                    value={props.value ? props.value : []}
                    filterData={props.filterData}
                />
        </>
    );
}